import {Injectable} from '@angular/core';
import {NumberOfChangeStock} from 'src/app/core/models/number-of-change-stock/number-of-change-stock';
import {Page} from 'src/app/core/utils/page';
import {ParametersDatabase} from "../../databases/parameters.database";

@Injectable({
    providedIn: 'root'
})
export class SqliteNumberOfChangeStockRepository {

    constructor(private readonly parametersDatabase: ParametersDatabase) {
    }

    async getNumberOfChangeStock(): Promise<Page<NumberOfChangeStock>> {
        const page = 0;
        const size = 20;

        const pagedDocs: NumberOfChangeStock[] = await this.parametersDatabase.queryObjects<NumberOfChangeStock>(
            `SELECT *
             FROM numberofchangestock
             LIMIT ${size} OFFSET ${page * size}`,
            null,
            []
        );

        const totalDocumentsCount: number = await this.parametersDatabase.count(
            `SELECT count(*)
             FROM numberofchangestock`
        );

        return {
            totalElements: totalDocumentsCount,
            totalPages: Math.ceil(totalDocumentsCount / size),
            first: page === 0,
            last: (page + 1) * size >= totalDocumentsCount,
            size: size,
            content: pagedDocs,
            number: page,
            numberOfElements: pagedDocs.length,
            empty: pagedDocs.length === 0
        };
    }
}
